import { ReactNode } from "react";
import { Colors } from "main";

type IconBlockGroupProps = {
  title?: string;
  children: ReactNode;
};

export function IconBlockGroup(props: IconBlockGroupProps) {
  const { children, title } = props;

  return (
    <div>
      {!!title && <h3 css={{ margin: 0, marginBottom: 16 }}>{title}</h3>}
      <div css={{ borderRadius: 8, backgroundColor: Colors.white200 }}>{children}</div>
    </div>
  );
}
